/**
 * Normalises a SHOUTED city name to ordinary capitalisation ("MERKSEM" → "Merksem").
 *
 * `partner.city` is free text typed by partners, and a good share of it is all-caps. That is
 * fine in a back-office table and shouts on a customer-facing card, next to a reverse-geocoded
 * city that comes back properly cased — the same list would mix "Merksem" and "MERKSEM".
 *
 * Only all-caps input is touched: a name carrying any lowercase is assumed to be cased
 * deliberately and is returned untouched, so "Sint-Niklaas" and "La Louvière" pass straight
 * through. Word boundaries are non-letters, which keeps hyphens and spaces
 * ("DOTTIGNIES - MOUSCRON" → "Dottignies - Mouscron"). An apostrophe is deliberately not a
 * boundary, so the Dutch elision stays lowercase the way the place is actually written
 * ("'S-HERTOGENBOSCH" → "'s-Hertogenbosch").
 */
export function cityCase(name: string | null | undefined): string | null {
    if (!name) return null;
    const trimmed = name.trim();
    if (!trimmed || /\p{Ll}/u.test(trimmed)) return trimmed || null;
    return trimmed
        .toLocaleLowerCase()
        .replace(/(^|[^\p{L}'])(\p{L})/gu, (_match, before: string, letter: string) => `${before}${letter.toLocaleUpperCase()}`); // prettier-ignore
}
